import React from 'react';
import {CloseButtonProps} from 'react-toastify';
import Button from '../../incase-domain/components/button/Button';

export function CustomCloseButton({closeToast}: CloseButtonProps): JSX.Element {
    return (
        <div onClick={(e) => closeToast(e)}>
            <Button variant="ghost" square size="sm" leading="ph:x" />
        </div>
    );
}
